<template>
  <div class="score-scale" aria-hidden="true">
    <div class="score-scale-bar">
      <span
        v-for="band in grades"
        :key="band.key"
        class="score-scale-segment"
        :style="{ flex: band.width, background: `var(--ex-scale-${band.key})` }"
      />
      <span class="score-scale-marker" :style="{ left: `calc(${position}% - 9px)` }" />
    </div>
    <div class="score-scale-labels">
      <span
        v-for="band in grades"
        :key="band.key"
        :style="{ flex: band.width }"
        :class="{ 'score-scale-label--current': band.key === grade }"
      >{{ band.label }}</span>
    </div>
  </div>
</template>

<script>
import { GRADES } from '../score/report.mjs'

export default {
  name: 'ScoreScale',
  props: {
    score: { type: [Number, String], required: true },
    // Key of the current grade, from getScoreGrade().
    grade: { type: String, required: true }
  },
  data () {
    return { grades: GRADES }
  },
  computed: {
    position () {
      return Math.min(Math.max(Number.parseFloat(this.score) * 10, 0), 100)
    }
  }
}
</script>

<style scoped>
.score-scale {
  width: 560px;
  max-width: 100%;
}

.score-scale-bar {
  position: relative;
  display: flex;
  gap: 3px;
}

.score-scale-segment {
  height: 8px;
  border-radius: var(--ex-radius-pill);
}

.score-scale-marker {
  position: absolute;
  top: -5px;
  width: 18px;
  height: 18px;
  border: 3px solid var(--ex-color-dark);
  border-radius: var(--ex-radius-pill);
  background: var(--ex-color-white);
}

.score-scale-labels {
  display: flex;
  flex-wrap: wrap;
  gap: 3px;
  margin-top: 10px;
  font-size: 12px;
  color: var(--ex-color-neutral-500);
}

.score-scale-labels span {
  white-space: nowrap;
}

.score-scale-label--current {
  font-weight: 600;
  color: var(--ex-color-dark);
}
</style>
